import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const moduleGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const moduleName = route.data['module'] as string | undefined;

    if (!moduleName) {
        return true;
    }

    if (authService.canAccessModule(moduleName)) {
        return true;
    }

    return router.createUrlTree([authService.getFirstAllowedRoute()]);
};